const pallete = {
  primary: {
    main: '#009AD8',
    light: '#B6E1FF',
    lighter: '#EDF8FF',
    dark: '#0845C5',
    darker: '#0E275D'
  },
  secondary: {
    main: '#EC7928',
    light: '#F9D7AF',
    dark: '#B74617'
  },
  success: {
    main: '#22C55E',
    light: '#77ED8B',
    darkL: '#118D57'
  },
  warning: {
    main: '#FFAB00',
    light: '#FFD666',
    dark: '#B76E00',
  },
  danger: {
    main: '#FF3B30',
    light: '#FFAC82',
    dark: '#B71D18',
  },
  curiousBlue: {
    50: "#F0FAFF",
    100: "#E0F4FE",
    200: "#B9EAFE",
    300: "#7CDAFD",
    400: "#36C8FA",
    500: "#0CB2EB",
    600: "#009AD8",
    700: "#0172A3",
    800: "#066086",
    900: "#0B4F6F",
    950: "#07334A",
  },
  grey: {
    100: '#F9FAFB',
    200: '#F4F6F8',
    300: '#DFE3E8',
    400: '#C4CDD5',
    500: '#919EAB',
    600: '#637381',
    700: '#060707ff',
    800: '#212B36',
  },
}

export default pallete